<ion-content class="main-admin">
  <app-header [isParentPage]="true" [title]="'Custom Reports'"></app-header>
     <div class="page-loader" style="padding-top:15%;" *ngIf="!loading">
           <ion-spinner></ion-spinner>
        </div>
  <div class="main-container">
    <div *ngIf="authService.user?.canViewCustomCancelReport " 
         class="item"
        (click)="viewCustomerReports(cancelReport)">
      Customer Cancel Report
    </div>

    <div *ngIf="authService.user?.canViewGarmentReturnReview "
         class="item"
         (click)="viewCustomerReports(returnReview)">
      Garment Return Review
    </div>
  </div>
</ion-content>